<!--
  Image aligned left with no text wrap.

  The tile is a solid block with the mountains knocked out (fill-rule="evenodd"),
  matching the mdi-image glyph on the "Add Image" button so the whole toolbar
  reads as one set.

  Reads against the mdi-format-float-* icons used for the wrap layouts: those put
  the text bars BESIDE the tile, these put them ABOVE and BELOW it — which is
  exactly the difference between the two families.

  Geometry (shared by all three): 24x24 box; full-width text bars at y=2.5 and
  y=19.9; an 11x11 tile at y=6.5 whose x origin is the only thing that varies
  (2 / 6.5 / 11 for left / center / right).

  Sized in % so the glyph fills Vuetify's 1em .v-icon box and scales with the
  button size (x-small in the bubble menu, small in the toolbar) the way the mdi
  webfont icons beside it do. `currentColor` picks up the active state.
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="currentColor"
    aria-hidden="true"
  >
    <rect x="2" y="2.5" width="20" height="1.6" rx="0.8" opacity="0.5" />
    <path
      fill-rule="evenodd"
      d="M3.5 6.5h8a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 2 16V8a1.5 1.5 0 0 1 1.5-1.5Z
         M3.6 16 L6.5 11.6 L8.3 14.2 L9.4 12.9 L11.4 16 Z"
    />
    <rect x="2" y="19.9" width="20" height="1.6" rx="0.8" opacity="0.5" />
  </svg>
</template>

<script>
export default {
  name: 'ImageAlignLeftIcon'
};
</script>
